import AppConst from '../config/app.const';

const TEAM_TROPHIES = 'teamTrophies';
const WIGE_STANDINGS = 'wigeStandingses';
const WIGE_STANDINGS_TROPHY = 'wigeStandingsTrophies';
const WIGE_RESULTS = 'wigeResultses';
const WIGE_RESULTS_TROPHY = 'wigeResultsTrophies';
const DTM = 'DTM';
const DRIVERS = 'drivers';
// const JUNIOR = 'Junior';
const XP = 'XP';
const RACES = 'races';
const IMAGE_TYPE_DEFAULT = 'light';
const BG_PRIMARY_CLASS = 'bg-primary';
const BG_MEDIUM_CLASS = 'bg-medium';
const BG_LIGHT_CLASS = 'bg-light';

export default class WigeDataModel {
  _drivers = {};
  _driversByUniqueID = {};
  _teams = {};
  _event = {};
  pixel = AppConst.PIXEL;
  _events = {};

  get ratings () {
    return [DRIVERS, XP.toLowerCase()];
  }

  get drivers () {
    return this._drivers;
  }

  set drivers (value) {
    this._drivers = value;
  }

  get teams () {
    return this._teams;
  }

  set teams (value) {
    this._teams = value;
  }

  get event () {
    return this._event;
  }

  set event (value) {
    this._event = value;
  }

  get events () {
    return this._events;
  }

  set events (value) {
    this._events = value;
  }

  get points () {
    return {
      race: [25, 18, 15, 12, 10, 8, 6, 4, 2, 1],
      qualifying: [3, 2, 1]
    };
  }

  parseDriversResponse (responseData) {
    const teamsData = {};
    const driversData = {};
    const driversUniqueIdData = {};
    responseData.forEach((driver) => {
      let age = 0;
      if (driver.appBirth) {
        const appBirthParts = driver.appBirth.split('.');
        const birthDay = new Date(appBirthParts[2], appBirthParts[1] - 1, appBirthParts[0]);
        const ageDifMs = Date.now() - birthDay.getTime();
        const ageDate = new Date(ageDifMs); // miliseconds from epoch
        age = Math.abs(ageDate.getUTCFullYear() - 1970);
      }
      driver.age = age;
      const year = driver.driverUniqueID.substr(-4);
      if (TEAM_TROPHIES in driver && driver.teamTrophies.length) {
        driver.team = {
          manufacturer: driver.teamTrophies[0].manufacturerTrophy,
          name: driver.teamTrophies[0].name
        };
      }
      if (driver.team) {
        teamsData[driver.team.name.toUpperCase()] = driver.team;
      }
      driversData[year + '-' + driver.driverNumber] = driver;
      driversUniqueIdData[driver.driverUniqueID] = driver;
    });
    this.drivers = driversData;
    this.driversByUniqueID = driversUniqueIdData;
    this.teams = teamsData;
  }

  parseStandingsResponse (response, raceSeries) {
    const resultName = raceSeries === DTM ? WIGE_STANDINGS : WIGE_STANDINGS_TROPHY;
    if (resultName in response) {
      this.event = {};
      response[resultName].forEach((entry) => {
        this.event = this.createEvent(entry);
      });
    }
  }

  parseResultResponse (response, raceSeries) {
    const responseName = raceSeries === DTM ? WIGE_RESULTS : WIGE_RESULTS_TROPHY;
    this.events = {};
    if (responseName in response) {
      const events = {};
      const eventIds = [];
      response[responseName].forEach((entry) => {
        let event = this.createEvent(entry);
        const jsonData = event.jsonData;
        if (!eventIds.includes(entry.wigeEventId)) {
          eventIds.push(entry.wigeEventId);
          events[event.wigeEventId] = event;
        } else {
          event = events[entry.wigeEventId];
        }
        this.parseEventSessions(event, jsonData);
      });
      const keys = Object.keys(events);
      if (keys.length === 1) {
        events[keys[0]].opened = true;
      } else if (keys.length > 1) {
        events[keys[keys.length - 1]].opened = true;
      }
      this.events = events;
    }
  }

  parseEventSessions (event, jsonData) {
    event.sessions.forEach((session, sessionIndex) => {
      if (jsonData && parseInt(session.sessionid) === parseInt(jsonData.sessionid)) {
        // set training to qualifying, if qualfying in session name
        if (session.name.toLowerCase().indexOf('qualifying') > -1) {
          session.type = 'qualifying';
        }
        this.parseEventResults(jsonData, session);
        session.resultOpen = false;
        session.result = jsonData.result;
        if (jsonData.result && jsonData.result.length && session.sessionid > event.activeSession) {
          event.activeSession = session.sessionid;
        }
      }
    });
  }

  parseEventResults (jsonData, session) {
    let currentPointValue = 0;
    jsonData.result.forEach((result) => {
      // firstName, lastName
      const name = this.formatName(result.name);
      result.firstName = name.firstName;
      result.lastName = name.lastName;
      result.driverUniqueID = this.formatUniqueId(result, session.date.substr(6));
      if (session.type in this.points) {
        // calculate points, if no sessionpoints
        if (!('sessionpoints' in result)) {
          result.points = 0;
          if (result.status === '' && currentPointValue < this.points[session.type].length) {
            result.points = this.points[session.type][currentPointValue];
            currentPointValue++;
          }
        } else {
          result.points = result.sessionpoints;
        }
      }
    });
  }

  createEvent (entry) {
    const event = {};
    const date = new Date(entry.startDate);
    event.jsonData = JSON.parse(entry.jsonText);
    event.wigeEventId = entry.wigeEventId;
    event.startDate = entry.startDate;
    event.endDate = entry.endDate;
    event.races = event.jsonData.pointsessions;
    event.year = date.getFullYear();
    event.manufacturers = event.jsonData.manufacturers ? event.jsonData.manufacturers : [];
    event.teams = event.jsonData.teams ? event.jsonData.teams : [];
    event.drivers = event.jsonData.drivers ? event.jsonData.drivers : [];
    event.junior = event.jsonData.Junior ? event.jsonData.Junior : [];
    event.xp = event.jsonData.XP ? event.jsonData.XP : [];
    event.wigeName = entry.wigeName || null;
    event.sessions = event.jsonData.sessions || null;
    event.type = entry.type || null;
    event.activeSession = -1;
    event.opened = false;
    if (event.wigeName) {
      if (event.wigeName.substr(0, 1) === '(') {
        event.wigeName = event.wigeName.substr(event.wigeName.indexOf(')') + 1).trim();
      }
      if (event.wigeName.indexOf('DTM') > -1) {
        event.wigeName = event.wigeName.replace('DTM', '').trim();
      }
    }
    if (event.drivers) {
      this.assignDriversData(event.drivers, event.year);
    }
    if (event.junior) {
      this.assignDriversData(event.junior, event.year);
    }
    if (event.xp) {
      this.assignDriversData(event.xp, event.year);
    }
    return event;
  }

  assignDriversData (eventData, year) {
    eventData.forEach((entry) => {
      if (entry) {
        entry.racepoints = 0;
        entry.qualifyingpoints = 0;
        const name = this.formatName(entry.name);
        entry.firstName = name.firstName;
        entry.lastName = name.lastName;
        entry.driverUniqueID = this.formatUniqueId(entry, year);
        if (RACES in entry) {
          entry.races.forEach((race) => {
            entry.racepoints += parseFloat(race.racepoints);
            entry.qualifyingpoints += parseFloat(race.qualifyingpoints);
          });
        }
      }
    });
  }

  formatUniqueId (data, year) {
    const firstName = data.firstName.replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase());
    const lastName = data.lastName.replace(/(^\w{1})|(\s{1}\w{1})/g, match => match.toUpperCase());
    let driverUniqueID = firstName + lastName + year;
    driverUniqueID = driverUniqueID
      .replace(/[ä]/g, match => 'ae')
      .replace(/[ü]/g, match => 'ue')
      .replace(/[ö]/g, match => 'oe')
      .replace(/[ó]/g, match => 'o')
      .replace(/[.]/g, match => '')
      .replace(/[é]/g, match => 'e')
      .replace(/[ ]/g, match => '');
    return driverUniqueID;
  }

  formatName (name) {
    name = name.replace('  ', ' ');
    const fullName = name.split(' ');
    let firstName = '';
    let lastName = name;
    if (fullName.length) {
      firstName = fullName[fullName.length - 1];
      // extra for Jan Philipp, Jose Maria
      if (name.indexOf('Jan Philipp') > -1 || name.indexOf('Jose Maria') > -1) {
        firstName = fullName[fullName.length - 2] + ' ' + fullName[fullName.length - 1];
      }
      lastName = name.substr(0, name.length - firstName.length).trim();
    }
    return { firstName: firstName, lastName: lastName };
  }

  getDriverImage (data, event) {
    const driver = this.getDriver(data, event);
    return driver && driver.image ? `https://media.graphcms.com/resize=w:120,fit:crop/quality=value:70/compress/${driver.image.handle}` : this.pixel;
  }

  getDriverFlag (data, event) {
    const driver = this.getDriver(data, event);
    return driver && driver.country && driver.country.appCountryFlag ? driver.country.appCountryFlag.url : this.pixel;
  }

  getDriverCountryName (data, event) {
    const driver = this.getDriver(data, event);
    return driver && driver.country ? driver.country.name : '';
  }

  getDriverFullname (data, event) {
    const driver = this.getDriver(data, event);
    const firstName = driver && driver.firstName ? driver.firstName : data.firstName;
    const lastName = driver && driver.lastName ? driver.lastName : data.lastName;
    return `${firstName} <b> ${lastName}</b>`;
  }

  getDriverTeamName (data, event) {
    const driver = this.getDriver(data, event);
    const teamName = driver && driver.team && driver.team.name ? driver.team.name : data.team;
    return `<span class="font-small">${teamName}</span>`;
  }

  getDriverManufacturerImage (data, event, type = IMAGE_TYPE_DEFAULT) {
    const driver = this.getDriver(data, event);
    const manufacturer = driver && driver.manufacturerTrophy ? driver.manufacturerTrophy : (driver && driver.team && driver.team.manufacturer ? driver.team.manufacturer : null);
    if (type !== IMAGE_TYPE_DEFAULT) {
      return manufacturer && manufacturer.imageDark ? manufacturer.imageDark.url : this.pixel;
    }
    return manufacturer && manufacturer.image ? manufacturer.image.url : this.pixel;
  }

  getDriverAdditionalRankingIcon (data, event) {
    const driver = this.getDriver(data, event);
    const driverAdditionalEntry = driver && driver.additionalRanking ? driver.additionalRanking : null;
    if (driver && driverAdditionalEntry) {
      if (driverAdditionalEntry === 'XP') {
        return `
           <svg class="results__additional-ranking" xmlns="http://www.w3.org/2000/svg" width="30" height="20" viewBox="0 0 49 22">
            <path fill="none" stroke="#00304F" stroke-width="1.5" d="M9.435 21l4.736-5.757L16.75 21h6.835l-4.676-9.925L27.542 1h-7.465L15.91 6.337 13.662 1H6.856l4.347 9.385L2 21h7.435zm23.844 0l1.374-6.297h4.538C46.09 14.703 48 9.816 48 6.907 48 3.639 45.492 1 42.147 1h-10.51l-4.39 20h6.032zm6.202-11.2h-3.454l.646-3.2h3.397c.955 0 1.545.427 1.545 1.341 0 1.189-1.095 1.859-2.134 1.859z"/>
          </svg>
        `;
      }
      if (driverAdditionalEntry === 'Junior') {
        return `
          <svg class="results__additional-ranking" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 17 21">
            <path fill="none" stroke="#00304F" stroke-width="1.5" d="M6.419 20c4.057 0 6.1-2.21 7.094-6.996L16 1h-5.288l-2.46 11.92c-.262 1.316-1.022 2.1-2.226 2.1-.89 0-1.832-.533-2.303-1.148L1 18.153C2.309 19.44 4.508 20 6.419 20z"/>
          </svg>
        `;
      }
      if (driverAdditionalEntry === 'G') {
        return `
          <svg class="results__additional-ranking" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 23 24">
            <g fill="none" fill-rule="evenodd">
              <g fill-rule="nonzero" stroke="#00304F" stroke-width="1.5">
                <path d="M652.623 417.25c4.852 0 5.964 1.773 8.223 4.317h0l-4.422 2.948c-1.662-2.17-2.854-2.29-4.438-2.297h-.346c-1.561 0-2.929.738-3.913 1.922-1.041 1.253-1.658 2.996-1.658 4.932 0 1.369.498 2.769 1.416 3.781.789.869 1.893 1.444 3.254 1.444 1.057 0 1.898-.288 2.497-.919.497-.523.824-1.259 1.01-2.19h0-4.029l.99-3.224h9.51l-1.667 6.817c-2.023 2.477-5.055 3.969-8.543 3.969-2.909 0-5.515-.957-7.369-2.646-1.785-1.628-2.888-3.938-2.888-6.77 0-3.48 1.322-6.5 3.529-8.652 2.199-2.144 5.284-3.432 8.844-3.432z" transform="translate(-639 -416)"/>
              </g>
            </g>
          </svg>
        `;
      }
    }
    return '';
  }

  getDriverTime (data) {
    if (data.status !== '') {
      return data.status;
    } else if (data.position === '1') {
      return data.time;
    }
    return data.gap.indexOf('L') > -1 ? data.gap : `+${data.gap}`;
  }

  getTeamImage (data, type = IMAGE_TYPE_DEFAULT) {
    const team = this.getTeam(data);
    const manufacturer = team && team.manufacturer ? team.manufacturer : null;
    if (type !== IMAGE_TYPE_DEFAULT) {
      return manufacturer && manufacturer.imageDark ? manufacturer.imageDark.url : this.pixel;
    }
    return manufacturer && manufacturer.image ? manufacturer.image.url : this.pixel;
  }

  getRowClass (data) {
    if (data.position === '1') {
      return BG_PRIMARY_CLASS;
    }
    if (data.position === '2' || data.position === '3') {
      return BG_MEDIUM_CLASS;
    }
    return BG_LIGHT_CLASS;
  }

  getTeam (data) {
    return this.teams[data.name.toUpperCase()];
  }

  getDriver (data, event) {
    let driver = null;
    if (event) {
      driver = this.drivers[`${event.year}-${data.number}`] || null;
    }
    driver = this.drivers[`${this.event.year}-${data.number}`] || null;
    // check names
    if (driver !== null && driver.firstName.toUpperCase() !== data.firstName.toUpperCase()) {
      driver = null;
    }
    if (!driver) {
      driver = this.driversByUniqueID[data.driverUniqueID] || null;
    }
    return driver;
  }
}
